"use client";

import { useEffect } from "react";

interface PageThemeProps {
  footerTheme: "payment" | "product-detail";
}

export default function PageTheme({ footerTheme }: PageThemeProps) {
  useEffect(() => {
    const body = document.body;
    const previousTheme = body.dataset.footerTheme;

    body.dataset.footerTheme = footerTheme;

    return () => {
      if (previousTheme) {
        body.dataset.footerTheme = previousTheme;
      } else {
        delete body.dataset.footerTheme;
      }
    };
  }, [footerTheme]);

  return null;
}
